<template>
  <div>
    <footer id="footerDesktop" class="bg-white py-2 parasec3-sec w-100 bottom-0">
      <div class="container">
        <div class="row p-0">
          <div class="col-md-4 d-flex align-items-center">
            <img src="/img/map.png" class="size-map" alt="Chile">
            <div>
              <span class="caption ml-3 text-muted">Chile</span>
            </div>
          </div>
          <div class="col-md-8 f-txt order-3 order-md-2 d-flex align-items-center justify-content-end">
            <div>
              <span class="caption text-muted">{{this.mimedYear}} Derechos Reservados | Imed S.A.</span>
            </div>
            <img src="/img/logo-imed-blue.svg" class="ml-3" alt="Imed">
          </div>
        </div>
      </div>
    </footer>
    <footer id="footerMovil" class="bg-white pb-2 pt-3 bottom-0">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-center align-items-center text-center">
            <div class="row">
              <div class="col-6 d-flex pl-0">
                <img src="/img/map.png" class="size-map" alt="Chile">
                <div class="pt-2">
                  <span class="caption text-muted ml-2">Chile</span>
                </div>
              </div>
              <div class="col-6 d-flex">
                <img src="/img/logo-imed-blue.svg" alt="Imed">
              </div>
            </div>
          </div>
        </div>
        <div class="row py-3">
          <div class="col-12 d-flex justify-content-center align-items-center text-center">
            <span class="caption text-muted">{{this.mimedYear}} Derechos Reservados | Imed S.A.</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    mimedYear: '',
    beforeMount() {
      this.mimedYear = new Date().getFullYear().toString();
    }
  }
</script>
<style lang="scss" scoped>
footer{
  bottom: 0;
}
#footerMovil{
  display: none;
}
.cc-1xry{
  bottom: 80px !important;
}
@media (min-width: 1200px){
  .container {
    max-width: 98% !important;
  }
}
@media screen and (max-width: 846px) {
  footer {
    position: absolute;
    width: 100%;
  }
  #footerDesktop{
    display: none;
  }
  #footerMovil{
    display: block;
  }
}
</style>
